var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"field-item space-between"},[_c('div',{staticClass:"field-label",class:{'required': _vm.required}},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"field-value space-between"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }